import { isPayBreakdownPath } from "@/payroll/pay-breakdown/routes";
import type { MarketingProduct } from "./types";

export const getMarketingProduct = (path: string): MarketingProduct | null => {
  if (path === "/payroll" || isPayBreakdownPath(path)) return "payroll";
  if (path === "/accounts-payable" || path.startsWith("/accounts-payable/"))
    return "accounts_payable";
  return null;
};
